import React from 'react'
import type {
  LotStoryArtifactDetailV1,
  LotStoryArtifactVersionV1
} from '../../types/lotStory'
import type {
  LotStoryLibraryVersionHistoryRowCompareActions,
  LotStoryLibraryVersionHistoryRowCompareState,
  LotStoryLibraryVersionHistoryRowPreviewActions,
  LotStoryLibraryVersionHistoryRowPreviewState,
  TranslateFn
} from './lotStoryLibraryTypes'
import type { LotStoryLibraryPresentation } from './lotStoryPresentation'
import LotStoryLibraryVersionHistoryRowHeader from './LotStoryLibraryVersionHistoryRowHeader'
import LotStoryLibraryVersionHistoryRowSummary from './LotStoryLibraryVersionHistoryRowSummary'

type LotStoryLibraryVersionHistoryRowProps = {
  t: TranslateFn
  artifact: LotStoryArtifactDetailV1
  version: LotStoryArtifactVersionV1
  previewState: LotStoryLibraryVersionHistoryRowPreviewState
  previewActions: LotStoryLibraryVersionHistoryRowPreviewActions
  compareState: LotStoryLibraryVersionHistoryRowCompareState
  compareActions: LotStoryLibraryVersionHistoryRowCompareActions
  presentation: LotStoryLibraryPresentation
}

export default function LotStoryLibraryVersionHistoryRow({
  t,
  artifact,
  version,
  previewState,
  previewActions,
  compareState,
  compareActions,
  presentation
}: Readonly<LotStoryLibraryVersionHistoryRowProps>) {
  const {
    lotStoryCardStyle,
    formatHistoryTimestamp
  } = presentation
  const isCurrentBundle = version.artifactVersionId === artifact.version.artifactVersionId

  return (
    <div
      style={{
        border: isCurrentBundle ? '1px solid #93c5fd' : '1px solid #e2e8f0',
        borderRadius: 10,
        backgroundColor: isCurrentBundle ? '#f8fbff' : '#ffffff',
        padding: 12,
        display: 'grid',
        gap: 10
      }}
    >
      <LotStoryLibraryVersionHistoryRowHeader
        t={t}
        artifact={artifact}
        version={version}
        previewState={previewState}
        previewActions={previewActions}
        compareState={compareState}
        compareActions={compareActions}
        formatHistoryTimestamp={formatHistoryTimestamp}
      />

      <LotStoryLibraryVersionHistoryRowSummary
        t={t}
        version={version}
        lotStoryCardStyle={lotStoryCardStyle}
        formatHistoryTimestamp={formatHistoryTimestamp}
      />
    </div>
  )
}